import { useQuery } from "@tanstack/react-query";
import { fetchHealth } from "@/lib/api";
import { cn } from "@/lib/cn";

export function HealthBadge() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["health"],
    queryFn: fetchHealth,
    refetchInterval: 30_000,
  });

  if (isLoading) return <span className="chip-vacio">backend …</span>;
  if (isError || !data) return <span className="chip-contradiccion">backend offline</span>;

  const title = `v${data.version} · db ${data.db} · ${new Date(data.timestamp).toLocaleTimeString("es-PE")}`;

  return (
    <span
      className={cn(data.status === "ok" ? "chip-probado" : "chip-hipotesis")}
      title={title}
    >
      backend {data.status} · db {data.db}
    </span>
  );
}
